import { IsBoolean, IsDateString, IsEnum, IsNotEmpty, IsOptional, IsString, Matches } from 'class-validator';
import { Genders } from '../../administrative';

export enum IdentityVerificationStatus {
  UNVERIFIED = 'unverified',
  PROCESSING = 'processing',
  VERIFIED = 'verified',
  FAILED = 'failed',
  REVIEW_REQUIRED = 'review_required',
}

export enum IdentityConciliationStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  PENDING = 'pending',
}

export const PERSON_NAME_REGEX = /^[\p{L}]+(?:[-'’][\p{L}]+)*$/u;
export const PERSON_NAME_REGEX_MESSAGE =
  'Seules les lettres, les accents, les apostrophes et les tirets sont autorisés (sans espaces ni symboles).';

export class UpdateUserIdentityNamesDto {
  @IsString()
  @IsNotEmpty()
  @Matches(PERSON_NAME_REGEX, {
    message: PERSON_NAME_REGEX_MESSAGE,
  })
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  @Matches(PERSON_NAME_REGEX, {
    message: PERSON_NAME_REGEX_MESSAGE,
  })
  lastName!: string;
}

export class UpdateUserIdentityDemographicsDto {
  @IsDateString()
  @IsNotEmpty()
  birthDate!: string;

  @IsEnum(Genders)
  @IsNotEmpty()
  gender!: Genders;
}

export class UserIdentityDto {
  @IsString()
  @IsNotEmpty()
  @Matches(PERSON_NAME_REGEX, {
    message: PERSON_NAME_REGEX_MESSAGE,
  })
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  @Matches(PERSON_NAME_REGEX, {
    message: PERSON_NAME_REGEX_MESSAGE,
  })
  lastName!: string;

  @IsDateString()
  @IsNotEmpty()
  birthDate!: string;

  @IsEnum(Genders)
  @IsNotEmpty()
  gender!: Genders;

  @IsEnum(IdentityVerificationStatus)
  @IsNotEmpty()
  verificationStatus!: IdentityVerificationStatus;
}

export class PatchUserVerificationStatusDto {
  @IsEnum(IdentityVerificationStatus)
  @IsNotEmpty()
  status!: IdentityVerificationStatus;

  @IsBoolean()
  @IsOptional()
  applyIdentityData?: boolean;

  @IsString()
  @IsOptional()
  note?: string;
}
